import React, { memo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';

import '../../../assets/sass/uiV3/component/_sidebarSponsorLogo.scss';
import LazyImage from '../../../components/CustomLibraries/LazyImage';

const SidebarSponsorLogo = ({ sponsor_logo }) => {
  const logos = typeof sponsor_logo != 'object' ? sponsor_logo?.split(',') : sponsor_logo;
  return (
    <>
      <div className="w-100 d-flex flex-column gap-3 bg-extra-light rounded-3 text-center p-3 p-sm-4 clr_v3_SidebarSponsorLogo">
        <h5 className="fs-5 fw-medium text-dark">Promoted By</h5>
        {/* single */}
        {logos?.length == 1 && (
          <div className="clr_v3_sponsor w-100">
            <div className="clr_v3_sponsor_slide w-100 position-relative">
              <LazyImage
                src={logos}
                alt="sponsor"
                className={`mw-100 mh-100 position-absolute translate-middle start-50 top-50`}
                logo
              />
            </div>
          </div>
        )}

        {/* multiple */}
        {logos?.length > 1 && (
          <Swiper
            className="clr_v3_sponsor w-100 text-center"
            navigation={false}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            effect={'fade'}
            autoplay={{
              delay: 2500
            }}
          >
            {logos.map((logo) => (
              <SwiperSlide className="clr_v3_sponsor_slide w-100 position-relative" key={logo}>
                <LazyImage
                  src={logo}
                  alt="sponsor"
                  className={`mw-100 mh-100 position-absolute translate-middle start-50 top-50`}
                  logo
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </>
  );
};

export default memo(SidebarSponsorLogo);
